import React, { FC } from 'react';
import { Box, ImageList, ImageListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScannerCase } from 'models/scanner-case';

type ScannerCasePreviewImagesProps = {
    scannerCase: ScannerCase;
    height?: number;
    cols?: number;
};
const ScannerCasePreviewImages: FC<ScannerCasePreviewImagesProps> = ({ scannerCase, height, cols }) => {
    const { t: translate } = useTranslation(['three-shape']);

    const translationName = (fileName: string) => {
        if (fileName.includes('.UpperJaw')) return 'UPPERJAWSCAN';
        if (fileName.includes('.sideview')) return 'BITESCAN';
        if (fileName.includes('.LowerJaw')) return 'LOWERJAWSCAN';
        if (fileName.includes('.UpperImplantScan')) return 'UPPERIMPLANTSCAN';
        if (fileName.includes('.LowerImplantScan')) return 'LOWERIMPLANTSCAN';
        return fileName;
    };

    return (
        <ImageList cols={cols ? cols : scannerCase.previewImages.length} sx={{ m: 0 }}>
            {scannerCase.previewImages.map((img) => (
                <ImageListItem key={img._id}>
                    {!height || height > 160 ? (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 1,
                                left: 1,
                                padding: '4px 8px',
                                backgroundColor: 'rgba(255,255,255,0.5)',
                                color: '#000',
                            }}
                        >
                            <Typography sx={{ padding: 0 }} variant="body2">
                                {translate(translationName(img.filename))}
                            </Typography>
                        </Box>
                    ) : undefined}

                    <img
                        style={{
                            height: height ? `${height}px` : '200px',
                            border: '1px #bbb solid',
                            background: 'rgba(250,250,250,1)',
                        }}
                        src={img.url}
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
};

export default ScannerCasePreviewImages;
